import React, { useLayoutEffect, useState } from "react";
import moment from "moment";
import { useSelector } from "react-redux";

const eve = [
  {
    name: "Breakfast",
    start_time: "06:00",
    end_time: "07:00",
    color: "bg-blue-50 text-blue-700 hover:bg-blue-100",
    colStart: 3,
  },
  {
    name: "Flight to Paris",
    start_time: "07:30",
    end_time: "09:30",
    color: "bg-pink-50 text-pink-700 hover:bg-pink-100",
    colStart: 3,
  },
  {
    name: "Meeting with design team at Disney",
    start_time: "10:00",
    end_time: "11:30",
    color: "bg-gray-100 text-gray-700 hover:bg-gray-200",
    colStart: 6,
  },
  {
    name: "Testing",
    start_time: "12:55",
    end_time: "19:55",
    color: "bg-gray-100 text-gray-700 hover:bg-gray-200",
    colStart: 1,
  },
];

// Function to calculate the grid row based on start and end times
const getGridRow = (start_time, end_time) => {
    const [startHour, startMinutes] = moment(start_time).format('HH:mm').toString().split(":").map(Number);
    const [endHour, endMinutes] = moment(end_time).format('HH:mm').toString().split(":").map(Number);

   // console.log(start_time,startHour, startMinutes)
   // console.log(end_time,endHour, endMinutes)

  
    // Calculate start and end grid rows
    const startRow = (startHour - 8) * 12 + Math.round(startMinutes / 5) + 2; // Offset by 2 for header
    const endRow = (endHour - 8) * 12 + Math.round(endMinutes / 5) + 2;
  
    // Calculate span between start and end rows
    const span = endRow - startRow;
  
    return `${startRow} / span ${span}`;
  };

const DayEvents = ({selectDate, showAfspraak}) => {
  const {userdetails,user,appointments} = useSelector((state) => state.appointment);
  const [events, setEvents] = useState(appointments);

  useLayoutEffect(() => {   
    let array = appointments.filter((item) => moment(item?.start_time).locale('nl-be').format('YYYY-MM-DD') === moment(selectDate?.date).locale('nl-be').format('YYYY-MM-DD'))
    
    setEvents(array);
  }, [selectDate]);

  return (
    <ol
      className="col-start-1 col-end-2 row-start-1 grid grid-cols-1 "
      style={{
        gridTemplateRows: "1.75rem repeat(180, minmax(1rem, 1fr)) auto",
      }}
    >
      {events.map((event, index) => (
         <li
         className="relative mt-px flex"
         //style={{ gridRow: "74 / span 12" }}
         onClick={()=>showAfspraak(event)}
         style={{ gridRow: getGridRow(event?.start_time, event?.end_time) }}

       >
          <a
            href="#"
            className={`group absolute inset-1 flex flex-col overflow-y-auto rounded-sm border-l-4 border-l-green-400 px-2 justify-center text-xs ${event?.color}`}
          >
            <div className="text-white"><p className="font-semibold text-white">{event?.invitees[0]?.name} - {event?.name}</p>
            <div>
              <p className="group-hover:text-current text-white">
              <time dateTime={event?.start_time}>
                {moment(event?.start_time).format("HH:mm")}
              </time>{" "}
              -{" "}
              <time dateTime={event?.end_time}>
                {moment(event?.end_time).format("HH:mm")}
              </time>
            </p></div>
            </div>
            
          </a>
        </li>
      ))}
    </ol>
  );
};

export default DayEvents;
